const setCatType1 = (payload) => {
  return {
    type: "catType1",
    payload,
  };
};

export default setCatType1;
